module.exports = __webpack_public_path__ + "img/PHIN-1.0ML.6d2ae0e7.png";